var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 -64 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m512 58.667969v266.664062c0 32.429688-26.238281 58.667969-58.667969 58.667969h-394.664062c-5.335938 0-10.453125-.640625-15.148438-2.132812-25.171875-6.613282-43.519531-29.441407-43.519531-56.535157v-266.664062c0-32.429688 26.238281-58.667969 58.667969-58.667969h394.664062c32.429688 0 58.667969 26.238281 58.667969 58.667969zm0 0",
    fill: "#eceff1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m149.332031 106.667969c0 23.5625-19.101562 42.664062-42.664062 42.664062-23.566407 0-42.667969-19.101562-42.667969-42.664062 0-23.566407 19.101562-42.667969 42.667969-42.667969 23.5625 0 42.664062 19.101562 42.664062 42.667969zm0 0",
    fill: "#ffc107"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m512 276.054688v49.277343c0 32.429688-26.238281 58.667969-58.667969 58.667969h-394.664062c-5.335938 0-10.453125-.640625-15.148438-2.132812l260.695313-260.695313c14.503906-14.503906 38.398437-14.503906 52.90625 0zm0 0",
    fill: "#388e3c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m363.945312 384h-305.277343c-5.335938 0-10.453125-.640625-15.148438-2.132812-25.171875-6.613282-43.519531-29.441407-43.519531-56.535157v-6.613281l122.878906-122.878906c14.507813-14.507813 38.402344-14.507813 52.90625 0zm0 0",
    fill: "#4caf50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.aa7810432b9ef5f8520dda95b6a45cec.svg";
export { ForwardRef as ReactComponent };